import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { escolaBehavior } from '../../../../models/escola.interface';
import {
  alunoSelecionado,
  AlunosService,
} from '../../../../private/admin/pages/alunos/alunos.service';
import { ButtonComponent } from '../../../button/button.component';
import { MenuService } from '../../../menu/menu.service';
import { ModalComponent } from '../../../modal/modal.component';
import { ModalService } from '../../../modal/modal.service';
import {
  OptionSelect,
  SelectComponent,
} from '../../../select/select.component';
import { UserService } from '../../../services/user/user.service';
import { StorageServiceService } from '../../../storage/storage-service.service';
import { ToastService } from '../../../toast/toast.service';
import {
  permissaoBehavior,
  PermissaoEnum,
} from './../../../../models/role.enum';
import { Menu } from '../../../menu/menu.component';
import { PrimeiroAcessoComponent } from './primeiro-acesso/primeiro-acesso.component';

@Component({
  selector: 'abrir-modal-perfil',
  standalone: true,
  imports: [ModalComponent, SelectComponent, ButtonComponent],
  templateUrl: './abrir-modal-perfil.component.html',
  styleUrl: './abrir-modal-perfil.component.scss',
})
export class AbrirModalPerfilComponent implements OnInit {
  protected readonly PermissaoRole = PermissaoEnum;

  valueChangePermissao!: OptionSelect;
  valueChangeEscola!: OptionSelect;
  valueChangeAluno!: OptionSelect;
  perfilResponsavel: boolean = false;
  error: boolean = false;
  optionEscolas!: OptionSelect[];
  optionAlunos!: OptionSelect[];
  optionPermissoes!: OptionSelect[];
  permissao!: permissaoBehavior;
  escola!: escolaBehavior;
  aluno!: alunoSelecionado;
  form = new FormGroup({
    escola: new FormControl('', Validators.required),
    role: new FormControl('', Validators.required),
    aluno: new FormControl(''),
  });

  menu: Menu[] = [
    {
      icon: 'local_library',
      label: 'Escolas',
      route: '/admin/escolas',
      checked: true,
    },
    {
      icon: 'gavel',
      label: 'Termos',
      route: '/admin/termos',
      checked: false,
    },
  ];

  user: any;

  constructor(
    private readonly userService: UserService,
    private readonly toast: ToastService,
    private readonly menuService: MenuService,
    private readonly modalService: ModalService,
    private readonly storageService: StorageServiceService,
    private readonly alunoService: AlunosService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    // this.storageService.limpar();
    this.buscarUser();
  }

  buscarUser() {
    this.userService.buscarUser(this.userService.user.documentId).subscribe({
      next: (user: any) => {
        if (user[0].escolas.length === 0) {
          user[0].permissaos.forEach((element: any) => {
            if (
              element.id === PermissaoEnum.ROLE_ADMIN ||
              element.id === PermissaoEnum.ROLE_DIRETOR
            ) {
              this.menuService.setMenu(this.menu);
              this.router.navigateByUrl('/admin/escolas');
              const permissao: permissaoBehavior = {
                label: element.role.replace('ROLE_', ''),
                documentId: element.documentId,
                id: element.id,
              };
              this.userService.permissao.next(permissao);
              this.storageService.salvarPermissaoSeNaoExistir(permissao);
              this.modalService.open(PrimeiroAcessoComponent);
              return;
            }
          });
        }

        this.user = user[0];
        if (this.storageService.obterEscola() !== undefined) {
          this.escola = this.storageService.obterEscola() as escolaBehavior;
          this.valueChangeEscola = {
            label: this.storageService.obterEscola()?.label as string,
            value: this.storageService.obterEscola()?.id,
          };
          this.form.controls.escola.setValue(
            String(this.storageService.obterEscola()?.id),
          );
        }

        if (this.storageService.obterPermissao() !== undefined) {
          this.permissao =
            this.storageService.obterPermissao() as permissaoBehavior;
          this.valueChangePermissao = {
            label: this.storageService.obterPermissao()?.label as string,
            value: this.storageService.obterPermissao()?.id,
          };
          this.form.controls.role.setValue(
            String(this.storageService.obterPermissao()?.id),
          );
        }

        if (this.storageService.obterAluno() !== undefined) {
          this.aluno = this.storageService.obterAluno() as alunoSelecionado;
          this.valueChangeAluno = {
            label: this.storageService.obterAluno()?.nomeAluno as string,
            value: this.storageService.obterAluno()?.id,
          };
          this.form.controls.aluno.setValue(
            String(this.storageService.obterAluno()?.id),
          );
        }

        if (
          user[0].permissaos.length === 1 &&
          user[0].permissaos[0].id === PermissaoEnum.ROLE_RESPONSAVEL &&
          user[0].escolas.length === 1
        ) {
          this.perfilResponsavel = true;
          this.escola = {
            label: user[0].escolas[0].nomeFantasia,
            documentId: user[0].escolas[0].documentId,
            id: user[0].escolas[0].id,
          };
          this.form.controls.escola.setValue(user[0].escolas[0].documentId);
          this.permissao = {
            label: user[0].permissaos[0].role,
            documentId: user[0].permissaos[0].documentId,
            id: user[0].permissaos[0].id,
          };
          this.form.controls.role.setValue(user[0].permissaos[0].documentId);
        }

        this.optionAlunos = user[0].alunos.map((opt: any) => {
          return {
            label: opt.nome,
            value: opt.documentId,
            id: opt.id,
          };
        });
        this.optionEscolas = user[0].escolas.map((opt: any) => {
          return {
            label: opt.nomeFantasia,
            value: opt.documentId,
            id: opt.id,
          };
        });
        this.optionPermissoes = user[0].permissaos.map((opt: any) => {
          return {
            label: opt.role.replace('ROLE_', ''),
            value: opt.documentId,
            id: opt.id,
          };
        });
      },
      error: () => {
        this.toast.notify({
          message: 'Erro ao buscar Usuário',
          type: 'ERROR',
        });
      },
    });
  }

  selecionar() {
    if (this.form.valid) {
      this.userService.escola.next(this.escola);
      this.userService.permissao.next(this.permissao);
      this.storageService.salvarEscolaSeNaoExistir(this.escola);
      this.storageService.salvarPermissaoSeNaoExistir(this.permissao);
      if (this.aluno) {
        this.alunoService.alunoSelecionado.next(this.aluno);
      }

      this.validarMenu();
      if (window && (window as any).ReactNativeWebView) {
        (window as any).ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'MODAL_SELECAO_CONFIRMADO',
            escola: this.escola,
            permissao: this.permissao,
          }),
        );
      }
      this.router.navigateByUrl('/admin/home');
      this.modalService.close();
    } else {
      this.toast.notify({
        message: 'Preencha o formulário corretamente !',
        type: 'WARNING',
      });
    }
  }

  validarMenu() {
    const menuSelecionado = this.menuService
      .getMenu()
      .find((menu) => menu.checked);

    this.menuService.updateMenu();

    if (menuSelecionado) {
      this.menuService.selectCurrentMenu(this.router.url);
    }
  }

  retornoOptionEscola($event: any) {
    this.escola = $event;
    // this.form.controls.escola.setValue($event.value);
    // this.userService.escola.next($event);
  }

  retornoOptionAluno($event: any) {
    this.aluno = {
      documentId: $event.value,
      id: $event.id,
      nomeAluno: $event.label,
    };
    this.form.controls.aluno.setValue($event.value);
    this.storageService.salvarAlunoSeNaoExistir(this.aluno);
  }

  retornoOptionRole($event: any) {
    this.permissao = $event;
    // this.form.controls.role.setValue($event.value);
    // this.userService.permissao.next($event);
  }

  get isResponsavel(): boolean {
    return (
      this.permissao?.id === this.PermissaoRole.ROLE_RESPONSAVEL &&
      this.user.alunos.length > 0
    );
  }
}
